import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import BankAccountService from "services/bankaccounts/bankaccount-service";
import StoreOrderService from "services/store-order/store-order-service";
import LogosNotification from "utils/notification-utils";

interface OrderPayManualDialogProps {
    order: any
    onClose: any,
    onRefreshData: any
};

const formInitialValue = {
    airwayBill: ''
};

const StoreOrderUpdateAirWayDialog: FC<OrderPayManualDialogProps> = ({ order, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        StoreOrderService.UpdateAirwayBill(order.id, values.airwayBill).then((res: any) => {
            onRefreshData(res.result);
        }).finally(() => {
            setIsSubmiting(false);
        });
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Update Nomor Resi {order.orderNumber}</ModalHeader>
                                <ModalBody pt={5}>

                                    <FormControl>
                                        <FormLabel htmlFor='bankName'>Expedisi: {order.shipment.expeditionService.fullName}</FormLabel>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.airwayBill && touched.airwayBill)}>
                                        <FormLabel htmlFor='bankName'>Nomor Resi</FormLabel>
                                        <Field
                                            as={Input}
                                            id='airwayBill'
                                            placeholder='Nomor Resi'
                                            name={'airwayBill'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nomor Resi wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.airwayBill}</FormErrorMessage>
                                    </FormControl>

                                </ModalBody>
                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Update</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default StoreOrderUpdateAirWayDialog;
